// 报销
import request from '@/utils/request'
import axios from 'axios'
import {
  getToken
} from '@/utils/auth'
// const BaseUrl = '/biz-counselor-affirm'
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  withCredentials: true,
  timeout: 10000
})
// /reimbursement/{id}
// 查询单个
export function queryById(id) {
  return request({
    url: '/reimbursement/' + id,
    method: 'get',
  })
}

// /reimbursement
// 添加
export function add(data) {
  return request({
    url: '/reimbursement',
    method: 'post',
    data
  })
}

//
// /reimbursement/{id}
// 删除
export function del(id) {
  return request({
    url: '/reimbursement/' + id,
    method: 'delete'
  })
}

// /reimbursement/deleteDetails/{id}
// 删除明细
export function delForm(id) {
  return request({
    url: '/reimbursement/deleteDetails/' + id,
    method: 'delete'
  })
}
// /reimbursement
// 修改
export function edit(data) {
  return request({
    url: '/reimbursement',
    method: 'put',
    data
  })
}

export function updateReceipt(data) {
  return request({
    url: '/reimbursement/review',
    method: 'post',
    params: data
  })
}
// 导出
export function downloadExcel(url, params, label, date) {
  service({
    method: 'get',
    url: url,
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${getToken()}`,
      filename: 'utf-8',
    },
    params
  }).then(res => {
    const fileName = `${label}.xls`
    const url = window.URL.createObjectURL(res.data)
    const link = document.createElement('a')
    link.style.display = 'none'
    link.href = url
    document.body.appendChild(link)
    link.setAttribute('download', fileName)
    link.target = '_blank'
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
  }).catch(error => {
    console.log(error)
  })
}
